module.exports = __webpack_public_path__ + "img/icon-story.6ef7316f.svg";